module.exports = __webpack_public_path__ + "img/bg01.8155dfff.png";